/**
 * Хук для проверки и обновления токена авторизации
 * 
 * Отвечает за:
 * - Проверку наличия и валидности токена
 * - Автоматическое обновление токена при необходимости
 * - Предоставление методов для ручного обновления токена
 */
import { isAuthenticated, refreshToken } from '../utils/authUtils';
import { useTranslation } from 'react-i18next';

/**
 * Хук проверки и обновления токена
 */
export const useTokenVerification = () => {
    const { t } = useTranslation();

    /**
     * Проверяет наличие токена и обновляет его при необходимости
     * @returns Promise<boolean> true если токен валиден или был успешно обновлен
     */
    const verifyToken = async (): Promise<boolean> => {
        // Проверяем наличие валидного токена
        const hasValidAccess = isAuthenticated();

        // Если есть валидный access token, токен в порядке
        if (hasValidAccess) {
            return true;
        }

        // Если access token отсутствует или недействителен,
        // пробуем обновить через refreshToken
        try {
            return await refreshToken();
        } catch (error) {
            console.error(t('errors.tokenVerificationError'), error);
            return false;
        }
    };

    return { verifyToken };
}; 